import { useEffect, useMemo, useState } from "react";
import { apiRequest } from "../../../../shared/api/client";
import { calculateSuggestion, suggestionDraft, type MikroPurchaseSuggestionResult, type SuggestedRequestDraft } from "./mikro-suggestion-model";
import { parseSuggestionResult } from "./mikro-suggestion-contract";

export function useMikroSuggestedRequestWorkspace({ onApply }: { onApply: (draft: SuggestedRequestDraft) => void }) {
  const [result, setResult] = useState<MikroPurchaseSuggestionResult | null>(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [includeOverdue, setIncludeOverdue] = useState(true);
  const [includeMinimumStock, setIncludeMinimumStock] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    apiRequest<unknown>(
      "/api/integrations/production/mikro/purchase-suggestions?limit=12",
      { cache: "no-store" },
    )
      .then((data) => {
        if (!active) return;
        setResult(parseSuggestionResult(data));
        setSelectedIndex(0);
      })
      .catch((reason) => {
        if (!active) return;
        setError(
          reason instanceof Error
            ? reason.message
            : "Mikro ihtiyaç önerileri alınamadı.",
        );
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [reloadKey]);

  const items = result?.items ?? [];
  const suggestion = items[selectedIndex] ?? null;
  const calculation = useMemo(() => calculateSuggestion(suggestion, includeOverdue, includeMinimumStock), [includeMinimumStock, includeOverdue, suggestion]);
  const move = (direction: -1 | 1) => {
    if (items.length < 2) return;
    setSelectedIndex((current) => (current + direction + items.length) % items.length);
    setIncludeOverdue(true);
    setIncludeMinimumStock(false);
  };

  const applySuggestion = () => {
    if (!suggestion || calculation.requestQuantity <= 0) return;
    onApply(suggestionDraft(suggestion, calculation, includeOverdue, includeMinimumStock));
  };
  return { result, selectedIndex, includeOverdue, setIncludeOverdue, includeMinimumStock, setIncludeMinimumStock, loading, error, setReloadKey, items, suggestion, calculation, move, applySuggestion };
}
